import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { HierarchicalTextBlock, ImageSkuBlock } from "@components"
import { SkuInfoBlockWrap } from "../@components"


export default function associatedSkuColumn() {
	return [ {
		name: "IAIdSkuName", label: "Associated SKU IA",
		options: {
			filterType: 'textField',
			display: false,
			customBodyRowRenderLite: (value, rowData) => {
				return <RenderAssociatedSkuIAColumn value={value} row={rowData} />
			}
		}
	}, {
		name: 'IAIdSku', label: 'Only Mapped IA',
		options: {
			display: 'excluded', filterType: "checkbox",
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}]
}


function RenderAssociatedSkuIAColumn({ row, value }) {
	const isMapped = !!row.IAIdSku

return <Box sx={{ display: 'flex', alignItems: 'center' }}>
		<ImageSkuBlock skuID={row?.IAIdSku} skuName={value} hideName  sx={{ mr: 2 }} isClickable={isMapped} secondaryBoxStyle={{ "span": { position: 'unset' } }} />
		<Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
			<SkuInfoBlockWrap sku={value} category={row.category} brand={row.skuBrand} />
			{!!row.IAIdSku && <HierarchicalTextBlock
				supertitle="SKU ID assigned by AI: "
				supertitleValue={row.IAIdSku}
				subtitle="IA options: "
				subtitleValue={row.IAOptionsData?.length}
			/>}
		</Box>
		
	</Box>
}